export default {
  autoReloadOffTooltip: 'Recarga automática desactivada',
  forceRefreshTooltip: 'Actualizar datos de los componentes',
  autoReloadOnTooltip: 'Última actualización {date}',
};
